import { getOssProxyOrFail } from "../api";

// TODO add a new better api route
// https://linear.app/metriport/issue/ENG-1840/add-auth-route-for-embed-dash-to-validate-the-token
export async function isAuthorizedForEmbed(): Promise<void> {
  const apiOssProxy = getOssProxyOrFail();
  await apiOssProxy.get(`/medical/v1/tcm/encounter?count=1`);
}
